import { render, staticRenderFns } from "./AgeGate.vue?vue&type=template&id=ad180d76&"
import script from "./AgeGate.vue?vue&type=script&lang=js&"
export * from "./AgeGate.vue?vue&type=script&lang=js&"
import style0 from "./AgeGate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports